import Joi from '@hapi/joi'

export const AdvancedStatusReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    fromDate: Joi.string().invalid("").label("From Date").required().messages({
        "any.required": `FromDate required`
    }),
    toDate: Joi.string().invalid("").label("To Date").required().messages({
        "any.required": `ToDate required`
    }),
    collectionPointID: Joi.number().required().label("Collectionpoint").messages({
        "any.invalid": `Collectionpoint cannot have invalid characters`,
        "any.required": `Collectionpoint required`
    }),
    status: Joi.string().invalid("").label("Status"),
    regNo: Joi.string().invalid("").label("RegNo").allow("", null)
}